import * as React from "react";
import { Routes, Route, BrowserRouter as Router } from "react-router-dom";
import CreatePost from "./pages/admin/CreatePost";
import CreateGallery from "./pages/admin/CreateGallery";
import PatientsList from "./pages/admin/PatientsList";
import AdminPanel from "./pages/admin/AdminPanel";
import EditPatientsList from "./pages/admin/AddPatient";
import AddPatient from "./pages/admin/AddPatient";
import EditPatient from "./pages/admin/EditPatient";
import DeletePatient from "./pages/admin/DeletePatient";
import MainPage from "./pages/MainPage";
import Expertise from "./pages/Expertise";
import ContactUs from "./pages/ContactUs";
import SingleContentShow from "./pages/SingleContentShow";
import NotFound from "./pages/NotFound";
import PrivateLayout from "./pages/layout";
import PublicLayout from "./pages/layout/PublicLayout";
import ScrollToTop from "./pages/components/ScrollToTop";
import ErrorFallback from "./helpers/ErrorFallback";
import { ErrorBoundary } from "react-error-boundary";

export interface iState {
  username: string;
  id: number;
  status: boolean;
}
export interface IAuth {
  authState: iState;
  setState: (newSession: iState) => void;
}
interface Props {}
const App: React.FC<Props> = (Props) => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallback}>
      <div className="App">
        <Router basename="/">
          <Routes>
            <Route
              path="/Admin/*"
              element={
                <PrivateLayout>
                  <Routes>
                    <Route path="CreatePost" element={<CreatePost />} />
                    <Route path="CreateGallery" element={<CreateGallery />} />
                    <Route path="PatientsList" element={<PatientsList />} />
                    <Route
                      path="EditPatientsList"
                      element={<EditPatientsList />}
                    />
                    <Route path="AdminPanel" element={<AdminPanel />} />
                    <Route path="AddPatient" element={<AddPatient />} />
                    <Route path="EditPatient/:id" element={<EditPatient />} />
                    <Route
                      path="DeletePatient/:id"
                      element={<DeletePatient />}
                    />
                  </Routes>
                </PrivateLayout>
              }
            />
            <Route path="/" element={<PublicLayout />}>
              <Route path="/Expertise" element={<Expertise />} />
              <Route path="/ContactUs" element={<ContactUs />} />
              <Route path="/" element={<MainPage />} />
              <Route
                path="/gallery/:id"
                element={<SingleContentShow category={"gallery"} />}
              />
              <Route
                path="/posts/:id"
                element={<SingleContentShow category={"posts"} />}
              />
              <Route path="*" element={<NotFound />} />
            </Route>
          </Routes>
          <ScrollToTop />
        </Router>
      </div>
    </ErrorBoundary>
  );
};

export default App;
